import GhHtmlElement from '@gudhub/gh-html-element';
import html from './channelSideBarItem.html';

class GhChannelSideBarItem extends GhHtmlElement {

    constructor() {
        super();
        this.discussedItems = [];
    }

    connectedCallback() {
        this.getAttributes();

        super.render(html);

        this.addEventListener('click', (event) => {
            if(event.target.closest('.users_sidebar__discussed_items_toggle')) {
                this.toggleDiscussedItems();
                return;
            }

            if(event.target.closest('gh-item-side-bar-item')) return;

            const conversations = this.closest('gudhub-messenger');
            if(conversations && !conversations.classList.contains('conversations--expanded')) {
                conversations.setExpanded(true);
            }
            this.closest('gh-users-side-bar').selectChannel(this, this.conversationId, this.name);
        });
    }

    getAttributes() {
        this.conversationId = this.getAttribute('conversation-id');
        this.name = this.getAttribute('name');
        this.unreadCount = Number(this.getAttribute('unread-count')) || 0;
    }

    //********************* SET UNREAD COUNT ********************************//
    // Updates this item's unread badge in place, without a full re-render.
    // * count (number) — new unread count; the badge is removed when 0
    setUnreadCount(count) {
        this.unreadCount = count;

        let badge = this.querySelector('.users_sidebar__unread_badge');

        if(count > 0) {
            if(!badge) {
                badge = document.createElement('span');
                badge.className = 'users_sidebar__unread_badge';
                this.appendChild(badge);
            }
            badge.textContent = count;
        } else {
            badge?.remove();
        }
    }

    //********************* TOGGLE DISCUSSED ITEMS ********************************//
    // Expands/collapses this row's "discussed items" list (see setDiscussedItems).
    toggleDiscussedItems() {
        this.classList.toggle('users_sidebar__user--discussed_items_expanded');
    }

    //********************* SET DISCUSSED ITEMS ********************************//
    // Called once by gh-users-side-bar after the initial render, with this
    // channel's "discussed items" - item-threads whose participants exactly
    // match this channel's current members. Re-renders to show the
    // toggle/list if there are any.
    // * items (Array<Object>) — [{ conversation_id, item_ref, unread_count, participants }]
    setDiscussedItems(items) {
        this.discussedItems = items;
        super.render(html);
    }

    //********************* ADD DISCUSSED ITEM ********************************//
    // Appends a newly created/joined item-thread to this row's "discussed
    // items" list, called by gh-users-side-bar when its participants match
    // this channel's current members.
    // * item (Object) — { conversation_id, item_ref, unread_count, participants }
    addDiscussedItem(item) {
        this.discussedItems.push(item);

        const list = this.querySelector('.users_sidebar__discussed_items');

        if(list) {
            list.insertAdjacentHTML('beforeend', this.renderDiscussedItem(item));
        } else {
            super.render(html);
        }
    }

    //********************* RENDER DISCUSSED ITEM ********************************//
    // Markup for a single "discussed items" row, shared by the template's
    // inline reduce and addDiscussedItem's insertAdjacentHTML.
    // * item (Object) — { conversation_id, item_ref, unread_count }
    renderDiscussedItem(item) {
        return `<gh-item-side-bar-item class="users_sidebar__user" conversation-id="${item.conversation_id}" app-id="${item.item_ref.app_id}" item-id="${item.item_ref.item_id}" view-id="${item.item_ref.view_id || ''}" unread-count="${item.unread_count}"></gh-item-side-bar-item>`;
    }
}

if(!customElements.get('gh-channel-side-bar-item')){
    customElements.define('gh-channel-side-bar-item', GhChannelSideBarItem);
}
